import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';
import { IByFlight } from '../RoundFlights';

export const getEnrollmentsByFlight = (
  enrollments: IEventEnrollment[],
  searchString: string
): IByFlight => {
  return enrollments.reduce((byFlight: IByFlight, enrollment) => {
    const name = `${enrollment.user.firstName} ${enrollment.user.lastName}`;
    const isValid =
      !String(searchString).length || name.toUpperCase().includes(searchString.toUpperCase());
    const id = (enrollment.flight ? enrollment.flight.id : 0) || 0;

    const list = (byFlight[id] || {}).enrollments || [];

    return {
      ...byFlight,
      [id]: {
        enrollments: list.concat(
          isValid
            ? [
                {
                  ...enrollment,
                  flight: enrollment.flight
                }
              ]
            : []
        ),
        expanded: !!String(searchString).length
      }
    };
  }, {});
};
